import React, { useState } from "react";
import { PrimaryButton } from "./PrimaryButton";
export function NameScreen({
  onSubmit
}: {
  onSubmit: (name: string) => void;
}) {
  const [value, setValue] = useState("");
  const valid = value.trim().length > 0;
  return <section className="mx-auto max-w-xl px-4 py-12 sm:px-6 md:py-20" aria-labelledby="name-title" data-id="element-106" data-mp="shjy9gi4jopo">
      <p className="text-sm font-semibold text-olive-700" data-id="element-107" data-mp="xf2bhj36cq3h">Personalización</p>
      <h2 id="name-title" className="mt-2 font-serif text-3xl font-semibold leading-tight text-cocoa sm:text-4xl" data-id="element-108" data-mp="1l5o5w7k9abv0">
        Antes de empezar, ¿cómo querés que te llamemos?
      </h2>
      <p className="mt-4 text-lg leading-relaxed text-cocoa-soft" data-id="element-109" data-mp="1bfd0shou5wmj">
        Así podemos mostrarte un resultado más personalizado sobre tu cena, tu hinchazón y tu digestión nocturna.
      </p>
      <form className="mt-8" onSubmit={e => {
      e.preventDefault();
      if (valid) onSubmit(value);
    }} data-id="element-110" data-mp="242pcfwtgkk12">
        <label htmlFor="nombre" className="text-sm font-semibold text-cocoa" data-id="element-111" data-mp="28va7t2s0j56p">
          Nombre
        </label>
        <input id="nombre" type="text" autoComplete="given-name" autoFocus maxLength={40} value={value} onChange={e => setValue(e.target.value)} placeholder="Ej: Mariana" className="mt-2 w-full rounded-2xl border-2 border-blush-100 bg-white px-5 py-4 text-lg text-cocoa placeholder:text-cocoa-faint transition-colors duration-150 focus:border-rose-600 focus:outline-none" data-id="element-112" data-mp="1myriy3js8sid" />
        <div className="mt-6" data-id="element-113" data-mp="21pi813tzpdhs">
          <PrimaryButton type="submit" disabled={!valid} data-id="element-114" data-mp="21scxj9rv1oi2">
            Continuar con mi test
          </PrimaryButton>
        </div>
      </form>
    </section>;
}